import https from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
const getFlowsKey = () => 'Flows';
const BASE_URL = 'automationapps/v1';
const _fetchFlows = (guid, sourceApp, portalId = PortalIdParser.get()) => https.get(`${BASE_URL}/summaries`, {
  query: {
    portalId,
    platformSourceApps: sourceApp,
    uuid: `${portalId}:${guid}`
  }
});
export const getFlows = (guid, sourceApp) => getFromEarlyRequest(getFlowsKey(), () => _fetchFlows(guid, sourceApp));
export default getFlows;